import { createRequest, titanApi } from "./titanApi";

const extendedApi = titanApi.enhanceEndpoints({ addTagTypes: ["roleValidation"] }).injectEndpoints({
  endpoints: (builder) => ({
    validate: builder.query({
      query: (data) => ({
        ...createRequest(`/api/users/session/validate`),
        method: "POST",
        body: { ...data },
      }),
      providesTags: ["roleValidation"],
    }),
  }),
  overrideExisting: false,
});

export const { useValidateQuery } = extendedApi;
